import { render, staticRenderFns } from "./SaveBrandBookmarkPopup.vue?vue&type=template&id=c7853f4a&scoped=true&"
import script from "./SaveBrandBookmarkPopup.vue?vue&type=script&lang=ts&"
export * from "./SaveBrandBookmarkPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7853f4a",
  null
  
)

export default component.exports